import FieldConfig from "../../proto/field-config";
import FieldDropdown from "../dropdown/dropdown";


export default class FieldDropdownDynamic extends FieldDropdown {

    public _options     : any

    constructor(config:FieldConfig) {
        super(config);

        // special
        // this._options               = null; //_.get(config,'options',[]); // [{value, label, color},...]
        this.options               = null; //_.get(config,'options',[]); // [{value, label, color},...]

        this.hasOptionWithNullValue = _.some(this.options, (option:any)=>option.value === null);

        // _.assign(this.components,{})

        // _.assign(this.classes, {
        //     PopoverMenu                 : '', // to add classes for popover menu shell
        //     PopoverMenuScrollContainer  : 'max-h-200', // to add classes for popover menu scroll container (max-h-200 for example)
        // })
    }

    // // assumed to be redefined
    // getOptions() {
    //     return this._options || [];
    // }

    getOptions() {
        return this.options || [];
    }

    /*** IMPORT EXPORT ***/

    toJson() {
        let result = super.toJson();
        result.options = this.options;

        return result;
    }




}
